import greenStar from "../icons/CircleStarGreen.png";
import IconDuration from "../icons/IconDuration.svg";
import IconInsurance from "../icons/IconInsurance.svg";
import IconInvestment from "../icons/IconInvestment.svg";
import IconMaintenance from "../icons/IconMaintenance.svg";
import IconSubsidy from "../icons/IconSubsidy.svg";
import IconTransfer from "../icons/IconTransfer.svg";
import star from "../icons/Star.svg";
import agreement from "../icons/agreement.svg";
import arrowRightTop from "../icons/arrow_right_top.svg";
import bluePie from "../icons/bluePieChart.png";
import blueWriting from "../icons/blueWriting.svg";
import callCalling from "../icons/call-calling.svg";
import carbon from "../icons/carbon-neutral.svg";
import condensation from "../icons/condensation.png";
import copy from "../icons/copy.svg";
import homeToGridDis from "../icons/disabledHomeToGrid.svg";
import panelToGridDis from "../icons/disabledPanelToGrid.svg";
import homeToPanelDis from "../icons/disabledhomeToPanel.svg";
import emailIcon from "../icons/emailIcon.svg";
import emailLight from "../icons/emailLightIcon.svg";
import enquiry from "../icons/enquiry.png";
import envelopeClosed from "../icons/envelop_closed.svg";
import featureImg1 from "../icons/featureImg1.svg";
import featureImg2 from "../icons/featureImg2.svg";
import featureImg3 from "../icons/featureImg3.svg";
import featureImg4 from "../icons/featureImg4.svg";
import fire from "../icons/fire.png";
import gridDis from "../icons/gridDis.svg";
import home from "../icons/home.svg";
import houseDis from "../icons/houseDis.svg";
import insight from "../icons/insight.svg";
import lightStar from "../icons/light_star.png";
import location from "../icons/location.svg";
import pannelDis from "../icons/pannelDis.svg";
import penWhite from "../icons/pen-white.png";
import phoneIcon from "../icons/phoneIcon.svg";
import phoneLight from "../icons/phoneLightIcon.svg";
import phoneOutline from "../icons/phone_outilen.svg";
import grayPie from "../icons/pieChartGray.svg";
import powerGrid from "../icons/power_grid.svg";
import share from "../icons/share.svg";
import signup from "../icons/signUp.svg";

import snowFlake from "../icons/snow-flake.png";

import commercial from "../icons/commercial.png";
import individual_home from "../icons/individual_home.png";
import industrial from "../icons/industrial.png";
import locationLight from "../icons/locationLight.svg";
import residential from "../icons/residential.png";
import solar from "../icons/solar-01.svg";
import solarPanel from "../icons/solar_panel.svg";
import starCircle from "../icons/starWithCircle.png";
import streamLine from "../icons/stream_line.svg";
import success from "../icons/success.png";
import supportNew from "../icons/supportnew 1.png";
import tap from "../icons/tap.svg";
import trophyCup from "../icons/tropgy_cup.svg";
import whiteApartment from "../icons/whiteApartment.svg";
import writing from "../icons/writing.svg";
export {
    agreement,
    arrowRightTop,
    bluePie,
    blueWriting,
    callCalling,
    carbon,
    condensation,
    copy,
    emailIcon,
    emailLight,
    enquiry,
    envelopeClosed,
    featureImg1,
    featureImg2,
    featureImg3,
    featureImg4,
    fire,
    grayPie,
    greenStar,
    gridDis,
    home,
    homeToGridDis,
    homeToPanelDis,
    houseDis,
    IconDuration,
    IconInsurance,
    IconInvestment,
    IconMaintenance,
    IconSubsidy,
    IconTransfer,
    insight,
    lightStar,
    location,
    locationLight,
    panelToGridDis,
    pannelDis,
    penWhite,
    phoneIcon,
    phoneLight,
    phoneOutline,
    powerGrid,
    share,
    signup,
    snowFlake,
    solar,
    solarPanel,
    star,
    starCircle,
    streamLine,
    success,
    supportNew,
    tap,
    trophyCup,
    whiteApartment,
    writing,
};

export const dashboardSvgIcon = (
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4.9065 20.2981C4.434 20.2981 4.03175 20.1322 3.69975 19.8004C3.36791 19.4684 3.202 19.0654 3.202 18.5914V8.2069C3.202 7.7329 3.36791 7.32998 3.69975 6.99815C4.03175 6.66615 4.43475 6.50015 4.90875 6.50015H9.12125V4.90765C9.12125 4.43348 9.28716 4.03065 9.619 3.69915C9.951 3.36782 10.3533 3.20215 10.826 3.20215H14.174C14.6467 3.20215 15.049 3.36815 15.381 3.70015C15.7128 4.03198 15.8787 4.4349 15.8787 4.9089V6.50015H20.0912C20.5652 6.50015 20.9682 6.66615 21.3002 6.99815C21.6321 7.32998 21.798 7.7329 21.798 8.2069V18.5914C21.798 19.0654 21.6321 19.4684 21.3002 19.8004C20.9682 20.1322 20.566 20.2981 20.0935 20.2981H4.9065ZM4.90875 18.8991H20.0912C20.1682 18.8991 20.2388 18.8671 20.303 18.8031C20.367 18.739 20.399 18.6684 20.399 18.5914V8.2069C20.399 8.1299 20.367 8.0594 20.303 7.9954C20.2388 7.93123 20.1682 7.89915 20.0912 7.89915H4.90875C4.83175 7.89915 4.76116 7.93123 4.697 7.9954C4.633 8.0594 4.601 8.1299 4.601 8.2069V18.5914C4.601 18.6684 4.633 18.739 4.697 18.8031C4.76116 18.8671 4.83175 18.8991 4.90875 18.8991ZM10.5202 6.50015H14.4797V4.9089C14.4797 4.8319 14.4477 4.7614 14.3837 4.6974C14.3196 4.63323 14.249 4.60115 14.172 4.60115H10.828C10.751 4.60115 10.6804 4.63323 10.6162 4.6974C10.5522 4.7614 10.5202 4.8319 10.5202 4.9089V6.50015Z"
            fill="currentColor"
        />
    </svg>
);

export const connectionTypeIcons = {
    RESIDENTIAL_SOCIETY: residential,
    COMMERCIAL: commercial,
    INDUSTRIAL: industrial,
    INDIVIDUAL_HOMES: individual_home,
};

export const statusImages = {
    hot: fire,
    cold: snowFlake,
    mild: condensation,
};
